export abstract class _UserCreateModel {
  name: string;
  email: string;
  permissions?: string;
  userIcon: string;
  role?: string;
  profile?: object;

}